import React from 'react';
import { closeApp } from '@/util/helper/liff';
import { usePreventScrolling } from '@/util/hook/custom';
import useEffect from '@/util/hook/useEffect';
import useState from '@/util/hook/useState';
import { BUTTON_TYPE } from '@/config/ui/button';
import { MODAL_CLOSING_COUNTDOWN_SECOND } from '@/config/ui/time';
import { SEMANTIC_COLORS } from '@/constant/unit/color';
import { S } from './style';
import { BackButton, ForwardButton } from '../../atom/Button';
import Spinner from '../../atom/Spinner';
const useCountDownToCloseApp = ({ isClosingApp, second, setSecond, }) => {
    useEffect(() => {
        if (!isClosingApp)
            return;
        const intervalId = setInterval(() => {
            setSecond((prev) => {
                // close app before rendering 0 on the UI
                if (prev === 1) {
                    closeApp();
                }
                return prev - 1;
            });
        }, 1000);
        if (second === 0)
            clearInterval(intervalId);
        // eslint-disable-next-line consistent-return
        return () => clearInterval(intervalId);
    });
};
const renderBackButton = ({ noButtonTitle, noButtonSize, noButtonType, noButtonLink, onNoButtonClick, }) => (<BackButton isAvailable onButtonClick={onNoButtonClick} size={noButtonSize} type={noButtonType} href={noButtonLink}>
    {noButtonTitle}
  </BackButton>);
const renderForwardButton = ({ yesButtonTitle, yesButtonSize, yesButtonType, yesButtonLink, isYesButtonLoading, onYesButtonClick, }) => (<ForwardButton isAvailable={!isYesButtonLoading} isLoading={isYesButtonLoading} spinner={<Spinner size='20px' color={SEMANTIC_COLORS.DEFAULT_ICON}/>} onButtonClick={onYesButtonClick} size={yesButtonSize} type={yesButtonType} href={yesButtonLink}>
    {yesButtonTitle}
  </ForwardButton>);
const renderCountdown = ({ second }) => (<>
    <S.TextBlack>(將在倒數後關閉頁面)</S.TextBlack>
    <S.CountDown>{second}</S.CountDown>
  </>);
export default function Modal({ content, image, yesButtonTitle, yesButtonSize, yesButtonType = BUTTON_TYPE.BUTTON, yesButtonLink, onYesButtonClick, isYesButtonLoading, noButtonTitle, noButtonSize, noButtonType = BUTTON_TYPE.BUTTON, noButtonLink, onNoButtonClick, isError, isClosingApp = false, isPreventScrollingDisabled = false, }) {
    const [second, setSecond] = useState(MODAL_CLOSING_COUNTDOWN_SECOND);
    // #NOTES
    // prevent-scrolling behavior is disabled
    // to stop the document body from being scrollable when the modal unmount
    // while the popup is still opened
    usePreventScrolling(isPreventScrollingDisabled);
    // trigger countdown to close the app if isClosingApp is true
    useCountDownToCloseApp({ isClosingApp, second, setSecond });
    return (<S.Overlay onClick={(e) => e.stopPropagation()}>
      <S.Body isError={isError}>
        {image ? <S.Img src={image}/> : null}
        {content}
        {isClosingApp ? (renderCountdown({ second })) : (<S.LayoutButtons>
            {noButtonTitle
                ? renderBackButton({
                    noButtonTitle,
                    noButtonSize,
                    noButtonType,
                    noButtonLink,
                    onNoButtonClick: onNoButtonClick,
                })
                : null}
            {noButtonTitle ? <S.Space width={40}/> : null}
            {yesButtonTitle
                ? renderForwardButton({
                    yesButtonTitle,
                    yesButtonSize,
                    yesButtonType,
                    yesButtonLink,
                    isYesButtonLoading,
                    onYesButtonClick: onYesButtonClick,
                })
                : null}
          </S.LayoutButtons>)}
      </S.Body>
    </S.Overlay>);
}
